module.exports = __webpack_public_path__ + "assets/img/16_1742.193bab22.jpg";